import React from 'react';
import PropTypes from 'prop-types';
import {DEFAULT_COLOR_SCALE} from '../../colors';
import {scaleValues} from '../../hooks';
import {formatUnits} from 'common/utils/units-util';
import {t} from 'common/utils/translation-util';

import './index.scss';

const BuildingTrafficHeatMapLegend = ({
  legendColorScale,
  legendMaxValue,
  legendMinValue,
  legendUnit,
}) => {
  const formatNumber = (num) => {
    const levels = [
      {value: 1, symbol: '', decimal: 1},
      {value: 1e3, symbol: 'k'},
      {value: 1e6, symbol: 'M'},
      {value: 1e9, symbol: 'G'},
      {value: 1e12, symbol: 'T'},
      {value: 1e15, symbol: 'P'},
      {value: 1e18, symbol: 'E'},
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const levelIndex = levels.findIndex((level) => num < level.value) - 1;
    const level = levels[levelIndex];
    return level
      ? (num / level.value)
          .toFixed(level.decimal ? level.decimal : 0)
          .replace(rx, '$1') + level.symbol
      : num;
  };

  return (
    <div className={'LegendContainer'}>
      <div className={'LegendUnit'}>{legendUnit}</div>
      <div
        className={'LegendScale'}
        style={{
          background: `linear-gradient(to right, ${legendColorScale.join(
            ', ',
          )})`,
        }}
      />
      <div className={'LegendValues'}>
        {scaleValues(legendMinValue, legendMaxValue).map((value, index) => (
          <div className={'LegendValue'} key={index}>
            {formatNumber(value)}
            {index === legendColorScale.length - 1 ? '+' : null}
          </div>
        ))}
      </div>
    </div>
  );
};

BuildingTrafficHeatMapLegend.propTypes = {
  legendColorScale: PropTypes.array,
  legendMaxValue: PropTypes.number,
  legendMinValue: PropTypes.number,
  legendUnit: PropTypes.string,
};

BuildingTrafficHeatMapLegend.defaultProps = {
  legendColorScale: DEFAULT_COLOR_SCALE,
  legendMaxValue: 1000,
  legendMinValue: 0,
  legendUnit: formatUnits(t('Daily count/m^2')),
};

export default BuildingTrafficHeatMapLegend;
